import React from "react";
import { useNavigate } from "react-router-dom";
import grilleEval from "./img/grille_eval_en.png";
import { useT } from "./i18n";
import { renderRich } from "./RichText";
import "./styles/instruction_pages.css";

function AfterCoachPage() {
  const navigate = useNavigate();
  const t = useT();

  const goToEtude = () => {
    navigate("/etude");
  };

  const goToChatSelection = () => {
    navigate("/chat-selection");
  };

  return (
    <div className="page-container">
      <div>
        <h1 className="title">{t.afterCoach.title}</h1>
       
        <div className="description">
          <section className="section">
            <h2>{t.afterCoach.subtitle}</h2>
            <p>{renderRich(t.afterCoach.intro)}</p>
          </section>

          <section className="section">
            <h2>{t.afterCoach.notesHeading}</h2>
            <ul>
              {t.afterCoach.notes.map((item) => (
                <li key={item}>{renderRich(item)}</li>
              ))}
            </ul>
          </section>

          <section className="section">
            <p>{renderRich(t.afterCoach.gridIntro)}</p>
            <div>
              <img
                src={grilleEval}
                alt={t.afterCoach.gridAlt}
                className="image"
              />
            </div>
          </section>

          <section className="section">
            <p>{renderRich(t.afterCoach.questionnaireNote)}</p>
          </section>
        </div>

        <div className="button-container">
          <button className="button" onClick={goToEtude}>
            {t.common.previous}
          </button>

          <button className="button" onClick={goToChatSelection}>
            {t.common.next}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AfterCoachPage;
